import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ children }) => {
    const loginUserDetails = useSelector((state) => state.userDetails);
    if ([null, undefined, ""].includes(loginUserDetails.userType)) {
        return <Navigate to="/login" replace />;
    }
    return children;
};